export enum CrudActionEnum {
  Edit = 'edit',
  Add = 'add',
  AddWithDialog = 'addWithDialog',
  Delete = 'delete'
}

export enum PageLifecycleEventEnum {
  BeforeUnload = 'beforeunload',
  PageHide = 'pagehide',
  PageShow = 'pageshow'
}

export enum AvailabilityStatus {
  CheckedIn = 'checkedIn',
  Available = 'available',
  Reserved = 'reserved',
  Pending = 'pending',
  Confirmed = 'confirmed',
  Canceled = 'canceled',
  Archived = 'archived',
  Maintenance = 'maintenance',
  Rejected = 'rejected',
  InProgress = 'in progress',
  Accepted = 'accepted',
  Ready = 'ready',
  Finished = 'finished',
  Demo = 'demo',
  InUse = 'in_use'
}

export interface SelectOption {
  id?: number;
  departmentUnitId?: number;
  title?: string;
  value?: string;
}
